import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, actions } from '../../../store/dux/map-dux';

export function useMapRefresh() {
  const dispatch = useDispatch();
  const refresh = useCallback(() => dispatch(actions.refresh()), [dispatch]);

  return {
    refreshAt: useSelector(selectors.refresh),
    refresh,
  };
}
